import gsap from 'gsap';

export function category_mobile() {
    let categorie = document.querySelector('#sidebar');

    if(categorie == undefined) {
        categorie = null;
    }
    
    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    function autoClose(trigger) {
        if (window.innerWidth < 600) {
            if(trigger) {
                trigger.classList.add('close');
            }
        }
    }
    
    if(categorie) {
        categorie.addEventListener('click', (event) => {
            if(event.target.nodeName == "A") {
                event.stopPropagation;
            } else {
                if (window.innerWidth < 600) {
                    categorie.classList.toggle('close');
                }
            }
        });
    }
    autoClose(categorie);
    window.addEventListener('resize', debounce(() => autoClose(categorie), 150));
}